import * as R from 'ramda'

export const normalizePolyglotScope = R.replace(/¤/g, '.')

export const normalizeCustomLabels = customLabels => Object
  .keys(customLabels)
  .reduce((acc, key) => {
    acc[normalizePolyglotScope(key)] = customLabels[key]
    return acc
  }, {})
